import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import PopularSlider from '../../../../components/catalog/PopularSlider';
import usePrevious   from '../../../../../common/hooks/usePrevious';
import useRequest    from '../../../../common/services/request';

function renderDoorSliderBlock(data, index) {
  return (
    <DoorSliderBlock
      key={index}
      data={data}
    />
  );
}

const DoorSliderBlock = (props) => {
  const { t } = useTranslation();

  const {
          data: {
                  BACKGROUND_COLOR,
                  OFFERS,
                  URL: currentUrl,
                  LABEL,
                },
        } = props;

  const request = useRequest();

  const [items, setItems]     = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const popularModels = React.useMemo(() => {
    return items
      .filter((item) => {
        const [offer] = Object.values(item);

        const {
                common: {
                          isActive,
                          isDeleted,
                        },
              } = offer;

        return (DV.isUndefined(isActive) || isActive) && (DV.isUndefined(isDeleted) || !isDeleted);
      })
      .reduce((acc, model) => {
        const [offer] = Object.values(model);

        acc[offer.common.installationTypeId] ??= {
          items:              [],
          label:              offer.common.installationTypeUrlKey === 'v-dom'
                                ? t('client_in_house')
                                : t('client_in_apartment'),
          installationTypeId: offer.common.installationTypeId,
        };

        acc[offer.common.installationTypeId].items.push(model);

        return acc;
      }, {});
  }, [items]);

  const getData = () => {
    if (DV.isNotEmptyString(currentUrl)) {
      setLoading(true);

      const promise = request.get(currentUrl);

      promise
        .then((response) => {
          const { items = [] } = response;

          setItems(items);
        })
        .catch(() => {
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (Array.isArray(OFFERS)) {
      setLoading(true);

      request.get(`/get-promotional-offers?field[]=offerId&query[]=${OFFERS.toString()}`)
        .then((response) => {
          const { items = [] } = response;

          setItems(items);
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const prevUrl = usePrevious(currentUrl);

  React.useEffect(() => {
    if (items.length === 0 || currentUrl !== prevUrl) {
      getData();
    }
  }, [currentUrl, prevUrl]);

  if (!DV.isNotEmptyArray(items)) {
    return null;
  }

  return (
    <section
      className={'popular'}
      style={{ backgroundColor: BACKGROUND_COLOR }}
    >
      <PopularSlider
        label={LABEL ?? ''}
        popularModels={popularModels}
      />
    </section>
  );
};

export default renderDoorSliderBlock;